import { render } from "./a-agent.vue?vue&type=template&id=2ead3f03&scoped=true"
import script from "./a-agent.vue?vue&type=script&lang=js"
export * from "./a-agent.vue?vue&type=script&lang=js"

import "./a-agent.vue?vue&type=style&index=0&id=2ead3f03&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ead3f03"]])

export default __exports__